import { Component, OnInit, Input } from '@angular/core';
import { PatientService } from '../../../../services/patient.service';
import { PromiseResult } from '../../../../models/PromiseResult';
import { invoice } from 'src/app/models/invoice';
import { TraceClassDecorator } from '@sentry/angular';

@Component({
    selector: 'app-invoicef',
    templateUrl: './invoicef.component.html',
    styleUrls: ['./invoicef.component.css']
})
@TraceClassDecorator()
export class InvoicefComponent implements OnInit {
    @Input('transaction_id')
    transaction_id: string = null;
    result: PromiseResult;
    memberValue;
    members: any = [];
    invoice_data: invoice = new invoice();
    success: boolean = null;
    error: string = '';
    refresh: boolean = false;
    selectedMemberName: string;
    displayModal: boolean = false;
    constructor(
        private readonly patientservice: PatientService,
    ) { }

    async ngOnInit() {
        this.result = {
            success: null,
            error: null,
            data: null
        };

        if (this.transaction_id == null) {
            this.result = {
                success: false,
                error: {
                    code: 'REQ_INV',
                    message: 'ID is invalid'
                },
                data: null
            };
        }
        await this.GetInvoice();
    }

    displayDialog() {
        this.GetInvoice();
    }

    private async GetInvoice() {
        await this.patientservice
            .fetchInvoice(this.transaction_id)
            .toPromise()
            .then((result) => {
                let fetched = result.data;

                if (!result.success) {
                    this.success = false;
                    this.error = result.error.message;
                } else {
                    this.success = true;
                    this.invoice_data = new invoice();
                    this.invoice_data.invoice_id = fetched.p_invoice.invoice_id;
                    this.invoice_data.invoice_to = fetched.p_accounts.first_name + (fetched.p_accounts.middle_name==null?'':fetched.p_accounts.middle_name) + fetched.p_accounts.last_name;
                    this.invoice_data.email = fetched.p_accounts.user_patient.users.e_email;
                    this.invoice_data.phone = fetched.p_accounts.primary_contact_number;
                    this.invoice_data.location = {
                        address: fetched.p_accounts.address_line_1,
                        city: fetched.p_accounts.city,
                        state: fetched.p_accounts.state_name,
                        country: fetched.p_accounts.country.country_name,
                        zip: fetched.p_accounts.zip_code,
                        final_location: "",
                    };
                    this.invoice_data.location.final_location = [this.invoice_data.location.address,
                    this.invoice_data.location.city,
                    this.invoice_data.location.state,
                    this.invoice_data.location.zip]
                        .filter((ele) => {
                            if (ele)
                                return ele;

                        }).join(", ");
                    this.invoice_data.payment = {
                        paid_by: fetched.payment_gateway_type,
                        no_card: false,
                        card: "",
                        card_no: ""
                    }
                    let i = 0;
                    this.invoice_data.transactions = [];
                    fetched.basket.item_list.forEach(ele => {
                        const tbp = {
                            description: ele.name,
                            amount: ele.rendered_amount,
                            date: fetched.created_at,
                            sr_no: ++i
                        }
                        this.invoice_data.transactions.push(tbp);
                    });
                    this.invoice_data.total = fetched.basket.rendered_total;
                    this.displayModal = true;
                }
            });
    }

    print() {
        window.print();
    }
}
